import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SigninAndUserAc from './SigninAndUserAc';
import logout from './Logout';
import $ from 'jquery';
import { ReCaptcha, loadReCaptcha as fetchReCaptchaFromReactRecaptcha } from 'react-recaptcha-google'

class LoginPage extends Component {
  constructor() {
    super();
    this.state = {
      errors: {},
      resetPwdMsg: false,
      loginVal: false,
      showPwd: false,
      createac: false,
      fields: {},
      recaptchaVerified: false,
      expiryTime: null
    };
  }

  componentDidMount = () => {
    fetchReCaptchaFromReactRecaptcha();

    if (this.captcha) {
      this.captcha.reset();
    }

    localStorage.clear();
    if (this.props.location.state !== undefined) {
      this.setState({ resetPwdMsg: this.props.location.state.resetPwdMsg });
    }
  }

  onLoadRecaptcha = () => {
    if (this.captcha) {
      this.captcha.reset();
    }
  }
  
  verifyCallbackApi = (response) => {
    var thisController = this;
    $.ajax({
      url: "/api/verify-recaptcha",
      type: 'POST',
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
      },
      data: { "response": response },
      async: false,
      contentType: false,
      success: function (res) {
        if (res.success) {
          thisController.state.recaptchaVerified = true;
          thisController.setState(thisController.state);
        } else {
          thisController.captcha.reset();
          logout();
        }
      }
    });
  }

  handleChangeForInputs = ({ target }) => {
    let fields = this.state.fields;
    fields[target.name] = target.value;
    this.setState({
      fields
    });
    this.validateFormInputs();
  }

  heartBeatApi = () => {
    let loginController = this;
    $.ajax({
      url: "/api/app/heartbeat",
      type: 'POST',
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      async: false,
      success: function (res) {
        if (res.success) {
          loginController.state.expiryTime = loginController.state.expiryTime - 300;
          loginController.setState(loginController.state);
        } else {
          logout();
        }
      }
    });
  }

  refreshTokenApi = () => {
    let loginController = this;
    $.ajax({
      url: "/api/app/refresh-token",
      type: 'POST',
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      async: false,
      success: function (res) {
        if (res.success) {
          localStorage.setItem("access_token", " " + res.authToken);
          localStorage.setItem("expires_in", res.expires_in);
          loginController.state.expiryTime = res.expires_in;
          loginController.setState(loginController.state);
        } else {
          logout();
        }
      }
    });
  }

  signin = (e) => {
    let errors = {};
    let loginController = this;
    e.preventDefault();
    if (this.validateFormInputs()) {
      if (this.state.recaptchaVerified) {
        let passwordVal = this.state.fields.password;
        let username = this.state.fields.username;
        let response = SigninAndUserAc({ username, passwordVal });
        if (response) {
          loginController.state.expiryTime = localStorage.getItem("expires_in");
          loginController.setState(loginController.state);

          // setInterval(function () {
          //   if (loginController.state.expiryTime > 600) {
          //     loginController.heartBeatApi();
          //   } else {
          //     loginController.refreshTokenApi();
          //   }
          // }, 300000);
          if (this.fetchAllProjectsApi()) {
            loginController.props.history.push('/projectmgmt');
          } else {
            loginController.props.history.push('/projects/createNewProject');
          }
        } else {
          errors["response"] = "Invalid Username/Password";
          loginController.setState({
            errors: errors,
            resetPwdMsg: false
          });
        }
      }
    }
  }

  fetchAllProjectsApi = () => {
    var projectResponse = false;
    $.ajax({
      url: "/api/project",
      async: false,
      method: 'GET',
      data: { "userId": JSON.parse(localStorage.getItem("user_details"))["userId"] },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      success: function (res) {
        if (res.success === true) {
          if (res.result.length > 0) {
            projectResponse = true;
          } else {
            projectResponse = false;
          }
        }
      }
    });
    return projectResponse;
  }

  validateFormInputs = () => {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields['username']) {
      formIsValid = false;
      errors["username"] = "*Please enter your registered Email ID";
    }

    if (typeof fields['username'] !== "undefined") {
      var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
      if (!pattern.test(fields["username"])) {
        formIsValid = false;
        errors["username"] = "*Please enter valid Email ID";
      }
    }

    this.setState({
      errors: errors
    });
    return formIsValid;
  }

  showPassword = () => {
    if (this.state.showPwd) {
      this.setState({ showPwd: false });
    } else {
      this.setState({ showPwd: true });
    }
  }

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.signin(e);
    }
  }

  render() {
    return (
      <div className="wrapper">
        <div className="row col-md-12 p-0 m-0">
          <div className="col-md-5">
            <form className="form-horizontal">
              <div className="card-body p-0">
                <div className="row">
                  <div className="col-lg-12 p-0">
                    <div className="card sign-in-right-tab">
                      <div className="card-body sign-in-page">
                        <div className="col-sm-12">
                          <div className="logoBox">
                            <img src="./assets/images/dheeai.png" alt="" />
                            <h5 className="signinTitle" style={{ color: '#0270c0' }} >Dhee.AI for Sales Desk</h5>
                            <div className="errorMsg" style={{ color: this.state.resetPwdMsg ? '#b2beb5' : 'red' }} name="response">{this.state.resetPwdMsg ?
                              <label>Your password has been reset successfully<br />New password sent to your mail</label> : this.state.errors.response}</div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="card-body">
                            <div className="col-9 p-0 mx-auto ">

                              <div className="input-group mb-3">
                                <input type="email" className="login-form" name="username"
                                  value={this.state.username} onChange={this.handleChangeForInputs} placeholder="Email ID" />
                                <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.username}</div>
                              </div>

                              <div className="input-group mb-3">
                                <input type={this.state.showPwd ? "text" : "password"} className="form-control sign-in- passinput" name="password"
                                  value={this.state.password} onChange={this.handleChangeForInputs} placeholder="Password" aria-label="Dhee password"
                                  onKeyDown={this.handleKeyDown} />
                                <div className="input-group-append">
                                  <button className="btn showPassbtn" type="button" onClick={this.showPassword}>{this.state.showPwd ? 'Hide' : 'Show'}</button>
                                </div>
                              </div>
                              <div className="fpass col-12 p-0">
                                <Link to="/forgotpassword"> Forgot Password</Link>
                              </div > <br />


                              <ReCaptcha
                                ref={(el) => { this.captcha = el; }}
                                render="explicit"
                                sitekey="6Lda-PoUAAAAAJcNRvLXI827ygaCcUIqA5r-wefu"
                                onloadCallback={this.onLoadRecaptcha}
                                verifyCallback={this.verifyCallbackApi}
                              /><br /><br />

                              <div className="card-footera">
                                <button type="button" className="btn btn-primary btn-block" onClick={this.signin}>Sign In</button>
                              </div>
                              <div className="input-group mb-3 ">
                                <div className="fpass col-12 p-0">
                                  <span style={{ color: '#b7b4c0' }}>New here?</span>
                                  <Link to="/signup/step1"> Create an account</Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="col-md-7 sign-in-form-bg" />
        </div>
      </div>
    );
  }

}

export default LoginPage;


// WEBPACK FOOTER //
// ./src/sales-desk/login/LoginPage.js